import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useEffect } from 'react';

import { usePageTracking } from '~/hooks/usePageTracking';
import NotFoundPage from '~/pages/NotFoundPage';
import SignupPage from '~/pages/SignupPage';
import { getLead } from '~/queries/getLead';
import { usePartnerReferralContext } from '~/tracking/usePartnerReferralContext';

import { BaseRouterContext } from './__root';

interface RouteParams {
  context: BaseRouterContext;
  params: {
    leadCode: string;
  };
}

export const Route = createFileRoute('/$leadCode')({
  loader: async ({ params, context }: RouteParams) => {
    const data = await context.queryClient.ensureQueryData(
      getLead(params.leadCode),
    );

    if (!data.partner || !data.prospect) {
      console.log('Redirecting to organic');
      redirect({ to: '/', throw: true });
    }
  },
  component: () => {
    const { leadCode } = Route.useParams();
    const { data } = useSuspenseQuery(getLead(leadCode));
    const { setPartnerReferralContext } = usePartnerReferralContext();

    usePageTracking('Personalised Signup Page');

    // Set the partner referral context for tracking
    useEffect(() => {
      if (data.partner?.positionId) {
        setPartnerReferralContext(leadCode, data.partner.positionId);
      }
    }, [leadCode, data.partner?.positionId, setPartnerReferralContext]);

    return (
      <SignupPage
        partner={data.partner}
        leadCode={leadCode}
        showContactButton={false}
      />
    );
  },
  errorComponent: NotFoundPage,
});
